import React from "react";
import PropTypes from "prop-types";
import { ThemeProvider } from "styled-components";

export const BrandedContent = ({ children, primaryColor, accentColor }) => (
  <ThemeProvider
    theme={{
      primaryColor,
      accentColor
    }}
  >
    {children}
  </ThemeProvider>
);

BrandedContent.displayName = "BrandedContent";

BrandedContent.propTypes = {
  primaryColor: PropTypes.string.isRequired,
  accentColor: PropTypes.string.isRequired
};

export default BrandedContent;
